const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const loginValidators = {
  email: (v) => {
    if (!v) return "Email is required";
    if (!emailRegex.test(v)) return "Please enter a valid email address";
    return null;
  },
  password: (v) => {
    if (!v) return "Password is required";
    if (v.length < 8) return "Password must be at least 8 characters long";
    if (!/[A-Z]/.test(v))
      return "Password must contain at least one uppercase letter";
    if (!/[a-z]/.test(v))
      return "Password must contain at least one lowercase letter";
    if (!/\d/.test(v)) return "Password must contain at least one number";
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(v))
      return "Password must contain at least one special character";
    return null;
  },
};

export const requestPasswordResetValidators = {
  email: (v) => {
    if (!v) return "Email is required";
    if (!emailRegex.test(v)) return "Please enter a valid email address";
    return null;
  },
};

export const resetPasswordValidators = {
  password: (v) => {
    if (!v) return "Password is required";
    if (v.length < 8) return "Password must be at least 8 characters long";
    if (!/[A-Z]/.test(v))
      return "Password must contain at least one uppercase letter";
    if (!/[a-z]/.test(v))
      return "Password must contain at least one lowercase letter";
    if (!/\d/.test(v)) return "Password must contain at least one number";
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(v))
      return "Password must contain at least one special character";
    return null;
  },
  confirmPassword: (password, confirmPassword) => {
    if (!confirmPassword) return "Please confirm your password";
    if (password !== confirmPassword) return "Passwords do not match";
    return null;
  },
};

//MFA Validation schema
export const otpValidator = (v) => {
  if (!v) return "OTP is required";
  if (!/^\d{6}$/.test(v)) return "OTP must be exactly 6 digits";
  return null;
};

// PIN login step-up validation (client-side format check only — lockout/attempt
// rules are enforced server-side)
export const pinValidator = (v) => {
  if (!v) return "PIN is required";
  if (!/^\d{6}$/.test(v)) return "PIN must be exactly 6 digits";
  return null;
};

const isSequentialPin = (v) => {
  const digits = v.split("").map(Number);
  const ascending = digits.every((d, i) => i === 0 || d === digits[i - 1] + 1);
  const descending = digits.every((d, i) => i === 0 || d === digits[i - 1] - 1);
  return ascending || descending;
};

const isRepeatedPin = (v) => /^(\d)\1+$/.test(v);

export const pinSetupValidators = {
  newPin: (v) => {
    if (!v) return "PIN is required";
    if (!/^\d{6}$/.test(v)) return "PIN must be exactly 6 digits";
    if (isSequentialPin(v)) return "Sequential PINs are not allowed";
    if (isRepeatedPin(v)) return "Repeated-digit PINs are not allowed";
    return null;
  },
  confirmPin: (newPin, confirmPin) => {
    if (!confirmPin) return "Please confirm your PIN";
    if (newPin !== confirmPin) return "PINs do not match";
    return null;
  },
};
